import { ActionTypes, ReduxAction } from './types';
import { Dispatch } from 'redux';
import { Message } from '../../api';

export const setNotificationField =
  (value: any, fieldName: string) =>
  async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_NOTIFICATION_FIELD,
      payload: { value: value, fieldName: fieldName },
    });
  };

/**
 * Ersetzt alle notifications mit eine neue Liste von Nachrichten.
 * Nutzung ist für mehrere Notifications gedacht. Bei Einzelnutzung -> {@link setNotification}
 * @param messages Messages die angezeigt werden sollen
 */
export const addNotifications =
  (messages?: Message[]) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.ADD_NOTIFICATIONS,
      payload: messages,
    });
  };
